import React from 'react'
import PropTypes from 'prop-types'

import {
  EmptyState,
  HelpLink,
  ScreenHeader,
} from '../../../../../../components/generic'
import MedStockBreadcrumb from './MedStockBreadcrumb'
import MedStockDateFilter from './MedStockDateFilter'
import { ButtonOLD } from '@lmc/ui-kit'
import Glyph from '../../../../../../LEGACY/Glyph'

export default function MedStockEmptyState(props) {
  const { item, medication, openStockLogModal, router } = props

  const helpLink =
    'https://support.logmycare.co.uk/en/articles/4851799-how-do-i-sign-scheduled-medication-in-the-carer-app'
  const imageSrc =
    'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/happy_logan.png'

  return (
    <div style={styles.wrapper}>
      <ScreenHeader
        backLink
        router={router}
        title={`Stock - ${medication.name}`}
        useGoBack
        isInnerChildren
      >
        <ButtonOLD
          id="add-medication-button"
          onClick={() =>
            openStockLogModal({
              resident: router.params.id,
              medication: router.params.medication_id,
              item: item.id,
              category: item.category,
            })
          }
          style={styles.addMedicationButton}
          type="primary"
          icon={<Glyph name="plus" />}
        >
          Stock Count
        </ButtonOLD>
      </ScreenHeader>
      <br />
      <MedStockBreadcrumb {...props} />
      <MedStockDateFilter {...props} />
      <EmptyState imageSrc={imageSrc} title="No Logs">
        <div>There are no logs in the current date range.</div>
        <div>You can choose a different range using the date filter above.</div>
        <div>
          Learn more about signing medications{' '}
          <a href={helpLink} target="_blank" rel="noreferrer">
            here
          </a>
          .
        </div>
      </EmptyState>
      <div style={styles.helpLinkContainer}>
        <HelpLink supportLink="https://support.logmycare.co.uk/en/articles/5351351-adding-a-stock-count-from-the-care-office" />
      </div>
    </div>
  )
}

MedStockEmptyState.propTypes = {
  endDate: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  medication: PropTypes.object.isRequired,
  openStockLogModal: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  setEndDate: PropTypes.func.isRequired,
  setStartDate: PropTypes.func.isRequired,
  startDate: PropTypes.object.isRequired,
  todayDate: PropTypes.object.isRequired,
}

const styles = {
  helpLinkContainer: {
    marginTop: 24,
  },
  wrapper: {
    padding: '24px 0px 48px',
    margin: '0px auto',
    maxWidth: 1080,
  },
}
